import api from '@/lib/axios';

import type { PaginatedResponse } from '@/types/tenant';
import type {
  CreateFormConfigPayload,
  FormConfigDto,
  FormConfigSummary,
  FormConfigVersionDto,
  UpdateFormConfigPayload,
} from '@/types/form';
import type { ListFilterPayload } from '@/types/filters';

// ============================================
// Query Params
// ============================================

export interface GetFormConfigsParams {
  page?: number;
  size?: number;
  sort?: string;
}

export interface GetFormVersionsParams {
  page?: number;
  size?: number;
}

// ============================================
// Form Configs CRUD
// ============================================

export const getFormConfigs = async (
  params: GetFormConfigsParams = {},
  body?: ListFilterPayload,
): Promise<PaginatedResponse<FormConfigSummary>> => {
  const response = await api.post<PaginatedResponse<FormConfigSummary>>(
    '/form-service/v1/form-configs/list',
    body ?? {},
    { params },
  );
  return response.data;
};

export const getFormConfigById = async (id: string): Promise<FormConfigDto> => {
  const response = await api.get<FormConfigDto>(`/form-service/v1/form-configs/${id}`);
  return response.data;
};

export const createFormConfig = async (
  data: CreateFormConfigPayload,
): Promise<FormConfigDto> => {
  const response = await api.post<FormConfigDto>('/form-service/v1/form-configs', data, {
    successToast: true,
  });
  return response.data;
};

export const updateFormConfig = async (
  id: string,
  data: UpdateFormConfigPayload,
): Promise<FormConfigDto> => {
  const response = await api.put<FormConfigDto>(`/form-service/v1/form-configs/${id}`, data, {
    successToast: true,
  });
  return response.data;
};

export const deleteFormConfig = async (id: string): Promise<void> => {
  await api.delete(`/form-service/v1/form-configs/${id}`, { successToast: true });
};

// ============================================
// Version History
// ============================================

export const getFormConfigVersions = async (
  id: string,
  params: GetFormVersionsParams = {},
): Promise<PaginatedResponse<FormConfigVersionDto>> => {
  const response = await api.get<PaginatedResponse<FormConfigVersionDto>>(
    `/form-service/v1/form-configs/${id}/versions`,
    { params },
  );
  return response.data;
};
